"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllMarkets = getAllMarkets;
const client_1 = require("@apollo/client");
const client_js_1 = require("../client.js");
const markets_js_1 = require("../queries/markets.js");
const GET_ALL_MARKETS = (0, client_1.gql) `
  ${markets_js_1.alphalendMarketsQuery}
`;
async function getAllMarkets(clientUrl) {
    const client = (0, client_js_1.getClient)(clientUrl);
    const { data, } = await client.query({
        query: GET_ALL_MARKETS,
        fetchPolicy: "no-cache",
    });
    const markets = data.allMarkets;
    return markets.map((market) => {
        if (market.coinType === "0x2::sui::SUI") {
            market.coinType =
                "0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI";
        }
        return market;
    });
}
//# sourceMappingURL=getMarkets.js.map